import React from 'react';
import { Grid, Hidden, Toolbar } from '@material-ui/core';
import TasksGridItem from '../TasksGridItem/TasksGridItem';
import Skeleton from '@material-ui/lab/Skeleton';
import './tasks-grid.scss';
import * as tasksActions from '../../../store/tasksSlice';
import * as regionsActions from '../../../store/regionsSlice';
import { connect } from 'react-redux';
import * as uiActions from '../../../store/uiSlice';
import ReactTouchEvents from 'react-touch-events';
import { useTranslation } from 'react-i18next';
import { completedRoutes } from '../../../common/constants';
import { useHistory } from 'react-router';

function TasksGrid(props) {
  const { tasksFetchingState, regionsFetchingState, userPlacesFetchingState } = props;
  const { t } = useTranslation();
  const history = useHistory();

  if (props.error !== null) {
    return null;
  }

  const isLoading = (
    tasksFetchingState === 'requesting' ||
    regionsFetchingState === 'requesting' ||
    userPlacesFetchingState === 'requesting'
  );

  const handleSwipe = (swipeDirection) => {
    switch (swipeDirection) {
      case 'right': {
        props.setSideBarOpenState({ open: true });
        break;
      }
      default:
        return;
    }
  };

  const handleClick = () => {
    history.push(completedRoutes.userForCompanies);
  };

  return (
    <>
      <ReactTouchEvents onSwipe={handleSwipe}>
        <Grid container spacing={2} className="tasks-grid-container">
          {isLoading ?
            <>
              <Grid item xs={12} sm={6} md={4}>
                <Skeleton variant="rect" className="skeleton" />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Skeleton variant="rect" className="skeleton" />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Skeleton variant="rect" className="skeleton" />
              </Grid>
            </>
            : (
              <>
                {
                  props.tasksIds.map((taskId) => {
                    const task = props.tasksById[taskId];
                    return (
                      <TasksGridItem task={task} key={task.id} />
                    )
                  })
                }
                <Grid item xs={12} sm={12} md={12}>
                  <div className="add-task" onClick={handleClick}>
                    <div className="title">{t('common.addTask')}</div>
                    <div className="circle-bnt">
                      <div />
                      <div />
                    </div>
                  </div>
                </Grid>
              </>
            )}
        </Grid>
      </ReactTouchEvents>
      {/*Для скролла ниже сетки*/}
      <Hidden mdUp>
        <Toolbar />
        <Toolbar />
      </Hidden>
    </>
  );
}

const mapStateToProps = state => ({
  tasksFetchingState: state.tasks.fetchingState,
  regionsFetchingState: state.regions.fetchingState,
  userPlacesFetchingState: state.places.userPlacesFetchingState,
  error: state.tasks.error,
  tasksIds: state.tasks.data.allIds,
  tasksById: state.tasks.data.byId,
  needUpdate: state.tasks.needUpdate,
});

const actionCreators = {
  fetchTasks: tasksActions.fetchTasks,
  fetchRegions: regionsActions.fetchRegions,
  setSideBarOpenState: uiActions.setOpenState,
  setNeedUpdate: tasksActions.setNeedUpdate,
};

export default connect(mapStateToProps, actionCreators)(TasksGrid);
